<template>
    <div>
        <carousel 
            :perPage="3"
            :perPageCustom="[[360, 1], [768, 3]]" 
            :autoplay="true" 
            :speed="1000" 
            :autoplayTimeout="4000" 
            :loop="true" 
            :paginationEnabled="true"
            :centerMode="true"
            :paginationActiveColor="colors.primary"
            paginationColor="#666666"
        >
            <slide>
                <div class="service-info-3">
                    <div class="detail">
                        <img :src="getS3Url('/images/icons/valuta.png')" class="img-responsive">
                        <h3>Valuta il tuo immobile</h3>
                        <p>Valuta il tuo immobile: ottieni subito un stima gratuita della tua proprietà.</p>
                        <div class="mt-4"><a href="/valuta-immobile" class="call-to-action">Scopri di più</a></div>
                    </div>
                </div>
            </slide>
            <slide>
                <div class="service-info-3">
                    <div class="detail">
                        <img :src="getS3Url('/images/icons/pubblica.png')" class="img-responsive">
                        <h3>Pubblica Annuncio</h3>
                        <p>Hai un immobile da vendere o affittare? Inserisci gratuitamente il tuo annuncio.</p>
                        <div class="mt-4"><button-scopri-piu :title="'Scopri di più'" :key="$root.userToken"></button-scopri-piu></div>
                    </div>
                </div>
            </slide>
            <slide>
                <div class="service-info-3">
                    <div class="detail">
                        <img :src="getS3Url('/images/mutuo.png')" class="img-responsive">
                        <h3>Calcola Mutuo</h3>
                        <p>Calcola la rata e trova la soluzione di mutuo giusta per te.</p>
                        <div class="mt-4"><a href="/calcola-mutuo" class="call-to-action">Scopri di più</a></div>
                    </div>
                </div>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';

    export default {
        props: ['colors'],
        components: {
            Carousel,
            Slide
        },
        methods: {
            getS3Url(path) {
                return process.env.MIX_ASSETS_URL_S3 + path;
            }
        }
    }
</script>
